'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DirectoryFormController = function () {

  /*@ngInject*/
  function DirectoryFormController(Upload, Directory, directory, $state, Slug, marked, $sce) {
    _classCallCheck(this, DirectoryFormController);

    this.errors = {
      saveDirectory: undefined,
      other: undefined
    };
    this.message = '';
    this.submitted = false;
    this.year = new Date().getFullYear();
    this.yearsToList = 2;
    this.years = [];
    this.categories = ['Restaurants', 'Hotels', 'Markets', 'Beer, Wine & Spirits', 'Entertainment', 'Appliance Installation', 'Band', 'DJ', 'Retail', 'Transportation', 'Realtors', 'Contractors', 'Landscapers', 'Roofing', 'Electrician', 'Plumbers', 'Painters', 'Bottled Gas', 'Land Surveyor', 'Mason', 'Handyman', 'Pool Care', 'Exterminator', 'Building Supplies', 'Carting Services', 'Insurance', 'Marinas', 'Auto Transport', 'Emergency Contacts', 'Cleaning Services', 'Government', 'Computer & IT Support', 'Health & Wellness', 'Misc.'];

    this.$sce = $sce;
    this.$marked = marked;
    this._$state = $state;
    this._Directory = Directory;
    this.$Uploader = Upload;
    this.$Slug = Slug;

    this.loading = false;

    this.mission = null;
    if (!directory) {
      this.setDirectory();
    } else {
      this.data = directory;
    }
    if (this._$state.current.name == 'directory.edit') {
      this.mission = 'edit';
      this.pageTitle = 'Edit Directory';
    } else {
      this.mission = 'new';
      this.pageTitle = 'Create New Directory';
    }
  }

  _createClass(DirectoryFormController, [{
    key: 'setDirectory',
    value: function setDirectory() {
      this.data = {
        title: '',
        town: '',
        phone: null,
        phoneAlt: null,
        url: null,
        address: {},
        category: [],
        note: null
      };
    }
  }, {
    key: 'saveDirectory',
    value: function saveDirectory(form) {
      var _this = this;

      this.submitted = true;
      console.log(form);
      if (form.$valid) {
        this.loading = true;
        this._Directory.save(this.data).then(function (res) {
          _this.loading = false;
          console.log('Result', res);
          _this._$state.go('directory.list');
        }).catch(function (err) {
          _this.loading = false;
          _this.error.saveDirectory = err.data.message;
          console.log('Error', err);
        });
      }
    }
  }]);

  return DirectoryFormController;
}();

exports.default = DirectoryFormController;


// WEBPACK FOOTER //
// ./client/app/directory/form/form.controller.js